export const FETCH_SUPPORTTYPE_ACTION = "FETCH_SUPPORTTYPE_ACTION";
export const FETCH_SUPPORTTYPE_FAIL_ACTION =
  FETCH_SUPPORTTYPE_ACTION + "_ERROR";
export const FETCH_SUPPORTTYPE_SUCCESS_ACTION =
  FETCH_SUPPORTTYPE_ACTION + "_SUCCESS";

export const ADD_SUPPORT_ACTION = "ADD_SUPPORT_ACTION";
export const ADD_SUPPORT_FAIL_ACTION = ADD_SUPPORT_ACTION + "_ERROR";
export const ADD_SUPPORT_SUCCESS_ACTION = ADD_SUPPORT_ACTION + "_SUCCESS";

export const FETCH_SUPPORTCENTER_ACTION = "FETCH_SUPPORTCENTER_ACTION";
export const FETCH_SUPPORTCENTER_FAIL_ACTION =
  FETCH_SUPPORTCENTER_ACTION + "_ERROR";
export const FETCH_SUPPORTCENTER_SUCCESS_ACTION =
  FETCH_SUPPORTCENTER_ACTION + "_SUCCESS";

export function fetchsupporttype() {

  return {
    type: FETCH_SUPPORTTYPE_ACTION,
  };
}
export function addsupport(value) {

  return {
    type: ADD_SUPPORT_ACTION,
    value: value,
  };
}

export function fetchsupportCenter(params) {
  return {
    type: FETCH_SUPPORTCENTER_ACTION,
    params: params,
  };
}
